import React, {
  useState,
  useContext
} from "react";
import { Context } from "../context";
import { getImage } from "./utils";
import { DayFilters } from "./DayFilters";
import { Playlist } from './Playlist';
import { withVersion } from './withVersion';
import { useEffect } from "react";


function PlaylistTopInner({
  playlistId,
  id,
  img,
  title,
  user,
  color,
  emoji,
  icon,
  size,
  filters = true,
  toggle,
  access = 'private'
}) {
  const context = useContext(Context);

  const [menu, setMenu] = useState(false);
  const [edit, setEdit] = useState(false);


  useEffect(() => {
    if (playlistName !== title) setPlaylistName(title)
  }, [title])


  const [playlistName, setPlaylistName] = useState(title);


  const playlistRename = context.handles.playlistRename;
  const playlistDelete = context.handles.playlistDelete;


  // const { id, img, title, user, color, emoji, icon } = getDataByUniq(context, "playlists", playlistId) || getDataById(context, "playlists", "default");
  return (
    <>
      {/* <Link to="/list/" style={{ width: "100%" }}> */}
      <div
        // className={`x_cover0 ${size === "sm" ? "x_cover0--sm" : ""}`}
        className={`x_cover0 x_cover0--sm`}
      >
        <div
          className="x_header_pic"
        // style={{
        //   backgroundImage: `linear-gradient(180deg, rgba(6, 161, 154, 0.7), rgba(6, 161, 154, 0.7)), url("${getImage(
        //     img,
        //     "large"
        //   )}")`,
        // }}
        />
        <div className="x_cover_content">

          <div className="">
            <div className="flex">
            <div className="x_cover_h1">
              <div className="flex">

                  {toggle['playlistIcon'] && <div className="x_cover_emoji">
                    {Boolean(emoji) && <>{emoji}</>}
                    {Boolean(icon) && <>{icon}</>}
                  {(!Boolean(icon) && !Boolean(emoji)) && <>list</>}
                  </div>}
                  {!edit && <div className="x_cover_title">{playlistName}</div>}
                  {edit && <input className="x_cover_title_input" value={playlistName} onChange={(e) => setPlaylistName(e.target.value)} />}
                </div>
              </div>
              <div className="x_button_container_main">
                <div className="x_button x_button--w">
                  {/* <div>Edit</div> */}
                  <div className="x_button_icon">
                    <div>edit</div>
                  </div>
                </div>
                <div className="x_button x_button--w">
                  {/* <div>Filters</div> */}
                  <div className="x_button_icon">
                    <div>checklist</div>
                  </div>
                </div>
              </div>
            </div>






            <div className="x_cover_h2">
              <div className="flex">
                <div className="flex center">
                  <div className="x_cover_createdby">Created by: </div>
                  <div className="x_user">
                    <div className="x_user_ava">
                      <img src="https://assets.website-files.com/61785133118e574036320746/6178c2817f2e698567910a6e_ava.png" loading="lazy" sizes="(max-width: 767px) 16px, (max-width: 991px) 2vw, (max-width: 1439px) 16px, 1vw" srcSet="https://assets.website-files.com/61785133118e574036320746/6178c2817f2e698567910a6e_ava-p-500.png 500w, https://assets.website-files.com/61785133118e574036320746/6178c2817f2e698567910a6e_ava.png 683w" alt className="p_user_ava_img p_user_ava_img--sm" />
                    </div>
                    <div className="x_user_name">
                      <span>Misha Miroshnikov</span>
                    </div>
                  </div>
                </div>
                <div className="flex center">
                  <div className="x_cover_createdby">Shared with:</div>
                  {access !== 'private' && <div className="x_privacy_label">
                    <div>Space</div>
                  </div>}
                  {access === 'private' && <div className="x_privacy_label x_privacy_label--private">
                    <div>Private</div>
                  </div>}
                </div>
              </div>
            </div>
          </div>








          <div className="x_button_container_right">

          {!edit && Boolean(playlistId) && (

            <div
              onClick={(e) => {
                e.stopPropagation();
                setEdit(!edit);
              }}
                class="x_button x_button--w">
                <div>Edit</div>
                <div class="x_button_icon">
                  <div>edit</div>
                </div>
              </div>

          )}

            {toggle['playlistFilters'] && filters && (

            <div
              onClick={(e) => {
                e.stopPropagation();
                setMenu(!menu);
              }}
                class="x_button x_button--w">
                <div>Filters</div>
                <div class="x_button_icon">
                  <div>checklist</div>
                </div>
              </div>

          )}

          </div>

        </div>




        {edit && <div className="x_playlist_actions">
          <div className="x_button_container_left">

            <div className="x_button x_button--main x_button--w"
              onClick={(e) => {
                e.stopPropagation();
                setEdit(!edit);
                playlistRename(playlistName)
              }}
            >
              <div>Save changes</div>
              <div className="x_button_icon">
                <div>check</div>
              </div>
            </div>

            <div className="x_button x_button--w"
              onClick={(e) => {
                e.stopPropagation();
                setEdit(!edit);
              }}
            >
              <div>Cancel</div>
            </div>
            <div className="x_button_container_right">


              {toggle['playlistImage'] && <div className="x_button x_button--w">
                <div>Image</div>
                <div className="x_button_icon">
                  <div>arrow_drop_down</div>
                </div>
              </div>}

              <div className="x_button x_button--w"
                onClick={(e) => {
                  e.stopPropagation();
                  playlistDelete(playlistId);
                }}
              >
                <div className="x_button_icon">
                  <div>delete</div>
                </div>
              </div>
            </div>
          </div>
        </div>}




      </div>
      {/* </Link> */}


      {menu && <DayFilters />}

    </>
  );
}


export const PlaylistTop = withVersion(PlaylistTopInner)